import { render, staticRenderFns } from "./FormRating.vue?vue&type=template&id=3fa33a1e&"
import script from "./FormRating.vue?vue&type=script&lang=js&"
export * from "./FormRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports